import { render, staticRenderFns } from "./CommissionTurnoverReportForm.vue?vue&type=template&id=b8d331ba&scoped=true"
import script from "./CommissionTurnoverReportForm.vue?vue&type=script&lang=js"
export * from "./CommissionTurnoverReportForm.vue?vue&type=script&lang=js"
import style0 from "./CommissionTurnoverReportForm.vue?vue&type=style&index=0&id=b8d331ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d331ba",
  null
  
)

export default component.exports